import { render, staticRenderFns } from "./OccurrenceTypeEdit.vue?vue&type=template&id=125742bf&"
import script from "./OccurrenceTypeEdit.js?vue&type=script&lang=js&"
export * from "./OccurrenceTypeEdit.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports